import {
  ChangeDetectionStrategy,
  Component,
  inject,
  input,
  InputSignal,
} from '@angular/core';
import { Observable } from 'rxjs';
import { IPageDTO } from '../../../dto/page/page.dto';
import { MediaService } from '../../../service/media.service';
import { MediasComponent } from '../medias/medias.component';
import { IUserDTO } from '../../../dto/user/user.dto';
import { IMediaDTO } from '../../../dto/media/media.dto';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-posts',
  imports: [MediasComponent],
  templateUrl: './posts.component.html',
  styleUrl: './posts.component.less',
})
export class PostsComponent {
  public readonly userDTO: InputSignal<IUserDTO> = input.required<IUserDTO>();
  private readonly mediaService: MediaService = inject(MediaService);

  public fetchMedias = (next?: string): Observable<IPageDTO<IMediaDTO>> => {
    return this.mediaService.fetchMedias(next);
  };
}
